/* @flow */

import type { SortableProductList } from "shop-state/types";

import type { Model } from "crustate";
import type { Response } from "./util";
import { updateData } from "crustate";

export type AdventCalendarDoorClosed = {|
  +__typename: "AdventCalendarDoorClosed",
  day: number,
  image?: {
    x1: string,
    x2: string,
  },
|};

export type AdventCalendarDoorToday = {|
  +__typename: "AdventCalendarDoorToday",
  +day: number,
  +variant: ?string,
  category: {
    name: string,
    +url: string,
    shortDescription: string,
    description: string,
    +products: SortableProductList,
    image?: {
      x1: string,
      x2: string,
    },
  },
|};

export type AdventCalendarDoorOpen = {|
  +__typename: "AdventCalendarDoorOpen",
  +day: number,
  +variant: ?string,
  category: {
    name: string,
    +url: string,
    shortDescription: string,
    description: string,
    image?: {
      x1: string,
      x2: string,
    },
  },
|};

export type AdventCalendarDoor =
  AdventCalendarDoorOpen |
  AdventCalendarDoorToday |
  AdventCalendarDoorClosed;

export type AdventCalendarDoors = $ReadOnlyArray<AdventCalendarDoor>;

export type AdventCalendar = {
  startDate: string,
  endDate: string,
  calendar: AdventCalendarDoors,
};

type Data =
  | { state: "LOADING" }
  | { state: "LOADED", data: AdventCalendar }
  | { state: "ERROR", error: string };

export type AdventCalendarResponse = Response<typeof ADVENT_CALENDAR_RESPONSE, ?AdventCalendar>;

export type AdventCalendarRequest = {
  tag: typeof ADVENT_CALENDAR_REQUEST,
  testDate?: string,
  password?: string,
};

export const adventCalendarActive = (
  currentDate: Date,
  dateStr: string,
  startDate: string,
  endDate: string
): boolean => {
  const timeZone = dateStr.slice(-6);
  const MIN_DATE: Date = new Date(`${startDate}T00:00:00${timeZone}`);
  const MAX_DATE: Date = new Date(`${endDate}T23:59:59${timeZone}`);

  return currentDate >= MIN_DATE && currentDate <= MAX_DATE;
};

export const ADVENT_CALENDAR_RESPONSE: "response/advent-calendar" = "response/advent-calendar";
export const ADVENT_CALENDAR_REQUEST: "request/advent-calendar" = "request/advent-calendar";

export const AdventCalendarModel: Model<
  Data,
  { testDate: ?string, password: ?string },
  AdventCalendarRequest | AdventCalendarResponse
> = {
  id: "advent-calendar",
  init: ({ testDate, password }: { testDate: ?string, password: ?string }) =>
    updateData(
      { state: "LOADING" },
      { tag: ADVENT_CALENDAR_REQUEST, testDate, password }
    ),
  update: (state, msg) => {
    switch (msg.tag) {
      case ADVENT_CALENDAR_RESPONSE:
        if (msg.error) {
          return updateData({ state: "ERROR", error: msg.error });
        }

        if (msg.data) {
          return updateData({ state: "LOADED", data: msg.data });
        }

        break;
      default:
    }
  },
};
